import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="stripe-connect"
export default class extends Controller {
  static values = { color: String, publishableKey: String, clientSecret: String }
  
  connect() {
    window.StripeConnect = window.StripeConnect || {};
    StripeConnect.onLoad = () => {
      const stripeConnectInstance = StripeConnect.init({
        publishableKey: this.publishableKeyValue,
        clientSecret: this.clientSecretValue,
        fonts: [
          {
            cssSrc: "https://fonts.googleapis.com/css2?family=Nunito",
          },
          {
            family: 'Nunito'
          }
        ],  
        appearance: {
          variables: {
            colorPrimary: this.colorValue
          },
        },
      });
      
      const accountOnboarding = stripeConnectInstance.create('account-onboarding');
      const accountOnboardingContainer = document.getElementById('account-onboarding-tab-pane');
      accountOnboardingContainer.appendChild(accountOnboarding);

      const payments = stripeConnectInstance.create('payments');
      const paymentsContainer = document.getElementById('payments-tab-pane');
      paymentsContainer.appendChild(payments);
    };
  }


}
